module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"navigateToFundSetup":"Missing data. Navigate to Fund Setup to complete."}}')
  delete Component.options._Ctor
}
